/**
 * Translation configuration
 *
 * Copyright (C) 2019D Noom, Inc.
 * @author nikola
 */

import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { enu } from "@noom/noomscape";

export const NAMESPACES = enu(["enrollment", "employerLanding"]);

export function init(): void {
  i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: false,
      fallbackLng: "en",
      load: "all",
      supportedLngs: ["en", "es"],
      interpolation: {
        escapeValue: false,
      },
      react: {
        transWrapTextNodes: "span",
      },
      ns: Object.keys(NAMESPACES),
      defaultNS: NAMESPACES.enrollment,
      fallbackNS: NAMESPACES.enrollment,
      backend: {
        loadPath: "/assets/locales/{{lng}}/{{ns}}.json",
      },
      detection: {
        lookupQuerystring: "lang",
      },
    });
}
